import type { ConsentState } from '@redbrickmedia/duplex.user-identity'
import {
  consentSnapshot,
  subscribeToConsent,
  type ConsentDecision,
} from './consentGate'

/**
 * Consent for pseudonymous identifiers sent to vendors: the targeting key (AY
 * `custom_8`, Mixpanel identity) and Mixpanel `user_id`.
 */
export function identifierConsentState(
  decision: ConsentDecision | null = consentSnapshot()
): ConsentState {
  return decision ? decision.identity : 'unknown'
}

export function mayShareIdentifiers(): boolean {
  return identifierConsentState() === 'allow'
}

/** Calls `onChange` whenever the identifier consent state moves on from the current one. */
export function onIdentifierConsentChange(
  onChange: (state: ConsentState) => void
): () => void {
  let last = identifierConsentState()
  return subscribeToConsent((decision) => {
    const next = identifierConsentState(decision)
    if (next === last) return
    last = next
    onChange(next)
  })
}
